module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/banner/id-a0428969261f495faeff543f406e3d22.jpg";